import { inject } from 'vue'

export const CONFIG_SYMBOL = Symbol('config')

export type DefaultConfig = {
    agreementUrl?: string
    conditionUrl?: string
    phone: null | string

    policyUrl?: string
    sector: number
    signature: string
    subscriptionState: boolean | null
}

export function useConfig<Config extends DefaultConfig>() {
    const config = inject<Config>(CONFIG_SYMBOL)

    if (!config) {
        throw new Error('Config is not provided')
    }

    return {
        config,
    }
}
